import apiClient from "./apiClient";
import {
  SearchUsersPageResponse,
  SearchUsersRequest,
  SearchUsersResponse,
  UserMeResponse,
  UserPasswordChangeRequest,
  UserProfileUpdateRequest,
  UserQuotaUpdateRequest,
  UserRoleUpdateRequest,
  UserUsernameUpdateRequest,
  OnboardingSourceStatsResponse,
} from "../../types/types";
import { API_ENDPOINTS } from "../../utils/config/constants";

export const UserApi = {
  me: async () => {
    const response = await apiClient.get<UserMeResponse>(API_ENDPOINTS.ME);
    return response.data;
  },
  updateMe: async (payload: UserProfileUpdateRequest) => {
    const response = await apiClient.put<UserMeResponse>(API_ENDPOINTS.ME, payload);
    return response.data;
  },
  updateUsername: async (payload: UserUsernameUpdateRequest) => {
    const response = await apiClient.put<UserMeResponse>(`${API_ENDPOINTS.ME}/username`, payload);
    return response.data;
  },
  changePassword: async (payload: UserPasswordChangeRequest) => {
    const response = await apiClient.put<void>(`${API_ENDPOINTS.ME}/password`, payload);
    return response.data;
  },
  requestAccountDeletion: async () => {
    await apiClient.post<void>(API_ENDPOINTS.ACCOUNT_DELETION_REQUEST);
  },
  searchUsers: async (payload: SearchUsersRequest) => {
    const response = await apiClient.post<SearchUsersPageResponse>(API_ENDPOINTS.USERS_SEARCH, payload);
    return response.data;
  },
  updateUserRole: async (userId: number, payload: UserRoleUpdateRequest) => {
    const response = await apiClient.put<SearchUsersResponse>(`${API_ENDPOINTS.USERS_ROLE}/${userId}/role`, payload);
    return response.data;
  },
  updateUserQuota: async (userId: number, payload: UserQuotaUpdateRequest) => {
    const response = await apiClient.put<SearchUsersResponse>(`${API_ENDPOINTS.USERS_ROLE}/${userId}/quota`, payload);
    return response.data;
  },
  deleteUser: async (userId: number) => {
    await apiClient.delete(`${API_ENDPOINTS.USERS_ROLE}/${userId}`);
  },
  saveOnboardingSource: async (sources: string[]) => {
    await apiClient.post(API_ENDPOINTS.ONBOARDING_SOURCE, { sources });
  },
  getOnboardingSource: async () => {
    const response = await apiClient.get<string[]>(API_ENDPOINTS.ONBOARDING_SOURCE);
    return response.data;
  },
  getOnboardingStats: async () => {
    const response = await apiClient.get<OnboardingSourceStatsResponse[]>(API_ENDPOINTS.ADMIN_ONBOARDING_STATS);
    return response.data;
  },
};
